module.exports = __webpack_public_path__ + "static/media/281124.21e02ab2.png";